// @ts-nocheck
import { useDispatch, useSelector } from "react-redux";
import { saveAlertMessage } from "./screens/redux/slice/alertMessage";
import { TOKEN } from "./screens/redux/api/Constants";
import AlertPopUp from "./components/Common/AlertPopup/alertPopup";
import { Spinner } from "react-bootstrap";
import ReactRoutes from "./routes";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppLogout from "./components/Layouts/AppLogout";

function App() {
  const dispatch = useDispatch();
  const alertMessage = useSelector((state) => state.alertMessage);

  const togglePopup = () => {
    dispatch(saveAlertMessage(null));
  };

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // For Loader
  const isSomeQueryPending = useSelector((state) =>
    Object.values(state.api.queries).some((query) => query.status === "pending")
  );

  // For Custom Loader
  const customLoader = useSelector((state) => state.loaderNoti);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // console.log(event);
      // Disable F12 and Ctrl + Shift + I (Developer Tools)
      if (
        event.key === "F12" || // F12 key
        (event.ctrlKey && event.shiftKey && event.key === "I") // Ctrl + Shift + I
      ) {
        event.preventDefault(); // Block the default action
      }
    };

    // window.addEventListener("keydown", handleKeyDown);

    // Clean up event listener
    // return () => {
    //   window.removeEventListener("keydown", handleKeyDown);
    // };
  }, []);

  const handleRightClick = (event) => {
    event.preventDefault(); // Prevent right-click context menu
  };

  useEffect(() => {
    if (customLoader == false) {
      setLoading(false);
    } else if (customLoader == true) {
      setLoading(true);
    }
  }, [customLoader]);

  useEffect(() => {
    let token = localStorage.getItem(TOKEN);
    if (location?.pathname.includes("/reset-password/")) {
      return;
    }
    if (!token) {
      navigate("/");
      return;
    }
    if (isSomeQueryPending) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [isSomeQueryPending]);

  // // const logoutTime = 5 * 60 * 1000; // 5 minutes
  // const logoutTime = 2 * 0.083333; // 5 minutes
  // useEffect(() => {
  //   let logoutTimer;

  //   const resetTimer = () => {
  //     clearTimeout(logoutTimer);
  //     logoutTimer = setTimeout(() => {
  //       alert("Session expired due to inactivity. Logging out...");
  //       // localStorage.removeItem("userToken"); // Clear session data
  //       // navigate("/login"); // Redirect to login page
  //     }, logoutTime);
  //   };

  //   // const events = ["mousemove", "keydown", "click"]; // User activity events
  //   const events = ["mousemove"]; // User activity events
  //   events.forEach((event) => window.addEventListener(event, resetTimer));

  //   resetTimer(); // Start timer on mount

  //   return () => {
  //     clearTimeout(logoutTimer);
  //     events.forEach((event) => window.removeEventListener(event, resetTimer));
  //   };
  // }, [navigate]);

  return (
    <div>
      {alertMessage && (
        <AlertPopUp alertMessage={alertMessage} togglePopup={togglePopup} />
      )}
      {loading && (
        <div
          style={{ zIndex: 1500, position: "fixed", top: "45%", left: "49%" }}
        >
          <Spinner
            animation="border"
            className="primary"
            togglePopup={togglePopup}
          />
        </div>
      )}
      <AppLogout>
        <ReactRoutes />
      </AppLogout>
    </div>
  );
}

export default App;
